import { NavigateFunction } from 'react-router-dom';

export const onNavigateWithRedirect = (navigate: NavigateFunction) => {
  const selectedThemeFromTemplates = localStorage.getItem(
    'selectedThemeFromTemplates',
  );
  const redirectFlag = localStorage.getItem('redirectFlag');

  if (redirectFlag === 'url') {
    localStorage.removeItem('redirectFlag');
    return navigate('/my-urls', { replace: true });
  }

  if (redirectFlag === 'qr') {
    localStorage.removeItem('redirectFlag');
    return navigate('/my-qrs', { replace: true });
  }

  if (selectedThemeFromTemplates && selectedThemeFromTemplates.length) {
    return navigate('/my-link', { replace: true });
  }
};
